import React from "react";
import PulseSelectButton from "../../PulseSelectButton/PulseSelectButton";

interface Step3WebProps {
  webFramework: string;
  onUpdateState: (value: string) => void;
}

const Step3Web: React.FC<Step3WebProps> = ({ webFramework, onUpdateState }) => {
  return (
    <>
      <h1 className="pl-heading-xl">Install SDK</h1>
      <div className="step-content">
        <div className="select-group">
          <h2 className="pl-heading-s">What framework are you using?</h2>
          <div className="side-by-side-buttons">
            <PulseSelectButton
              options={[
                { label: "React", value: "react" },
                // { label: "Next.js", value: "nextjs" },
                // { label: "Vue", value: "vue" },
                { label: "Angular", value: "angular" },
              ]}
              value={webFramework}
              onChange={onUpdateState}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step3Web;
